import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const getAddressList = createAsyncThunk(
  "customer-address/getAddressList",
  async ({ customer_id }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/customer-address-list", {
        params: {
          customer_id,
        },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const addOrupdateAddress = createAsyncThunk(
  "customer-address/addOrupdateAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/add-or-update-customer-address",
        payload,
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message.data || err.message || "Something went wrong ",
      );
    }
  },
);

export const deleteAddress = createAsyncThunk(
  "customer-address/deleteAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/delete-customer-address", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const setDefaultAddress = createAsyncThunk(
  "customer-address/setDefaultAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/set-default-customer-address",
        payload,
      );
      // console.log(
      //   "the res of selecting default address from thunk is :",
      //   res.data,
      // );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const getCustomerAddressById = createAsyncThunk(
  "customer-address/getCustomerAddressById",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/get-customer-address", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err.message || "Something went wrong",
      );
    }
  },
);
